'use client';

import type { CSSProperties } from 'react';
import { useRevealIn } from 'components/gifting/hooks/useRevealIn';
import styles from './FaqRow.module.css';

type Props = { question: string; answer: string; index: number };

// Design `.fqd-row.rv`: question left, answer right; fades up on scroll.
export const FaqRow = ({ question, answer, index }: Props) => {
  const [ref, inView] = useRevealIn<HTMLDivElement>();
  return (
    <div
      ref={ref}
      className={`${styles.row} ${inView ? styles.in : ''}`}
      style={{ '--rd': `${(index % 4) * 90}ms` } as CSSProperties}
    >
      <h3 className={styles.question}>{question}</h3>
      <p className={styles.answer}>{answer}</p>
    </div>
  );
};
